<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-search"></em></span>
    {{ "IQCStatusSearch.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  <span class="requiredStart">*</span>{{ "IQCStatusSearch.Search.Plant" | translate }}
                </div>
                <div class="block">
                  <laas-plant-dropdown
                    [isSingle]="true"
                    formControlName="plant">
                  </laas-plant-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IQCStatusSearch.Search.SpecLocType" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="specLocType"
                    [(ngModel)]="searchParams.specLocType"
                    [options]="specLocTypeOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [showClear]="true"
                    [maxSelectedLabels]="3"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IQCStatusSearch.Search.SKU" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="sku"
                    [(ngModel)]="searchParams.sku"
                    (keydown.enter)="$event.preventDefault()"
                  />
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IQCStatusSearch.Search.Status" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="statusList"
                    [(ngModel)]="searchParams.statusList"
                    [options]="statusOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [showClear]="true"
                    [maxSelectedLabels]="3"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  #arrivalDt
                  [title]="'IQCStatusSearch.Search.ArrivalDt'"
                  [enableMaxDateIsToday]="true"
                  [showRangeMode]="true"
                  [showStartMode]="false"
                  [defaultDate]="defaultArrivalDt"
                  (onDateChange)="dateOnChange($event, 'arrivalDt')"
                >
                </laas-calendar>
              </div>
            </div>
          </div>
          <div class="block">
            <small>
              <strong class="p-invalid">
                {{ 'IQCStatusSearch.Message.SearchFormNotification' | translate }}
              </strong>
            </small>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                type="button"
                (click)="searchBtnClick()"
                label="{{ 'Common.Button.Search' | translate }}"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                (click)="resetBtnClick($event)"
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Export' | translate }}"
                (click)="downloadExcelBtn($event)"
                class="ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #dataTable
        [dataKey]="'iqcKey'"
        [defaultColumns]="columns"
        [loading]="isLoading"
        [value]="searchResults"
        [selectable]="true"
        [(selectedRows)]="selectedRows"
        [isShowCreateRowFunction]="false"
      >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'currentStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : statusOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType" class="overflow-text">
                  <ng-container *ngSwitchCase="'date'">
                    {{
                      rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                    }}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
